import { Divider, Flex, Skeleton } from "antd";
import { ItemInfoBlock } from "components";
import { DefaultBankAccount, NominalAccountBankAccountsForBeneficiary, NOTIFICATION_TYPE_ENUM } from "interfaces";
import { useNotificationContext } from "providers";
import { useEffect, useRef, useState } from "react";
import { useStores } from "stores";
import { parseErrorMessage } from "utils";
import { getBankInfoColumn, getCompanyInfoColumn } from "../columns";
import { SAFE_DEAL } from "utils/envConstants";

export const OtpModalDescription = () => {
  const { user, actionModals, companyCard, nominalAccounts } = useStores();
  const [bankAccount, setBankAccount] = useState<DefaultBankAccount | null>(null);

  const [loading, setLoading] = useState(false);
  const { openNotification } = useNotificationContext();

  const fetchData = async () => {
    if (!user.userInfo?.id) {
      return;
    }
    setLoading(true);
    try {
      await companyCard.fetchCompanyCardById(user.userInfo?.company_id ?? "");

      if (SAFE_DEAL) {
        await nominalAccounts.fetchNominalAccountBankAccountsForBeneficiary(user.userInfo?.company_id ?? "");
        const account = nominalAccounts.nominalAccountBankAccountsForBeneficiary.find((item) => item.isDefault);
        setBankAccount(account as DefaultBankAccount);
      } else {
        setBankAccount(companyCard.card.defaultBankAccountDetails ?? null);
      }
    } catch (e: any) {
      openNotification({
        description: parseErrorMessage(e),
        type: NOTIFICATION_TYPE_ENUM.ERROR,
      });
    } finally {
      setLoading(false);
    }
  };

  const didFetch = useRef(false);

  useEffect(() => {
    if (didFetch.current) return;
    didFetch.current = true;

    fetchData();
  }, []);

  const bankInfoColumns = bankAccount ? getBankInfoColumn(bankAccount) : [];
  const companyInfoColumns = companyCard.card ? getCompanyInfoColumn(companyCard.card) : [];

  if (companyCard.fetchStatus === "error") {
    openNotification({
      description: "Ошибка в получении данных пользователя",
      type: NOTIFICATION_TYPE_ENUM.ERROR,
    });
    actionModals.closeAll();
  }

  return loading ? (
    <Flex vertical gap="small" className="margin-bottom-lg">
      <Skeleton loading />
      <Skeleton loading />
    </Flex>
  ) : (
    <>
      <ItemInfoBlock items={companyInfoColumns} oneColumn vertical={false} />
      <Divider />
      <ItemInfoBlock items={bankInfoColumns} oneColumn vertical={false} blockTitle="Банковские реквизиты" />
      <Divider />
    </>
  );
};
